/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Коллекция для получения районов города.
   */
  app.Districts = app.Collection.extend({
    model: app.Model,
    url: app.entryScriptName + '/api/v3/district/',

    /** @inheritDoc */
    run: function () {
      app.Collection.prototype.run.apply(this);
      this.listenTo(Backbone, 'reset-districts', this.reset);
    },
  });
})();

}.call(window));